import { render, staticRenderFns } from "./AdminBlockUser.vue?vue&type=template&id=c2af3144&scoped=true"
import script from "./AdminBlockUser.vue?vue&type=script&lang=js"
export * from "./AdminBlockUser.vue?vue&type=script&lang=js"
import style0 from "./AdminBlockUser.vue?vue&type=style&index=0&id=c2af3144&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2af3144",
  null
  
)

export default component.exports